export const formatTimeRange = (startTime: string): string => {
  const [hoursStr, minutesStr] = startTime.split(':');
  let hours = parseInt(hoursStr, 10);
  let minutes = parseInt(minutesStr, 10);

  minutes += 90;
  hours += Math.floor(minutes / 60);
  minutes = minutes % 60;
  hours = hours % 24;

  const endHours = hours.toString().padStart(2, '0');
  const endMinutes = minutes.toString().padStart(2, '0');

  return `${endHours}:${endMinutes}`;
};
